module.exports = __webpack_public_path__ + "img/mainImg.865be0b0.png";